import { nonEmptyStringValidator } from '@vista/omnichannel-components-domain';
import { Validator } from '@vista-digital/validator';
import { iconAssetValidator } from '../../../../validators/icon-asset';
/**
 * Default assets for the Member Photo Uploader component.
 */
export const defaultMemberPhotoUploaderAssets = {
    imageCropperRotateButtonIconName: 'rotate-right',
    imageCropperZoomOutButtonIconName: 'minus',
    imageCropperZoomInButtonIconName: 'plus',
    memberPhotoExamplesIcon: {
        name: 'member-photo-examples',
        viewBox: '0 0 306 200'
    },
    fileDropzonePromptIconName: 'person',
    fileDropzoneOverlayIconName: 'cloud-upload',
    lockedMemberPhotoIconName: 'lock',
    updatePhotoButtonIconName: 'pencil',
    failedToLoadDataIconName: 'generic-error-message'
};
export const memberPhotoUploaderAssetsValidator = Validator.object({
    imageCropperRotateButtonIconName: nonEmptyStringValidator,
    imageCropperZoomOutButtonIconName: nonEmptyStringValidator,
    imageCropperZoomInButtonIconName: nonEmptyStringValidator,
    memberPhotoExamplesIcon: iconAssetValidator,
    fileDropzonePromptIconName: nonEmptyStringValidator,
    fileDropzoneOverlayIconName: nonEmptyStringValidator,
    lockedMemberPhotoIconName: nonEmptyStringValidator,
    updatePhotoButtonIconName: nonEmptyStringValidator,
    failedToLoadDataIconName: nonEmptyStringValidator
});
